import { combinedClassNameSelector } from "@client/content/selectors";
import {
  combinedStyleSelector,
  getLayoutSettingValueSelector,
  getSettingSelector,
  getVisibilitySelector,
  TargetSelector
} from "@client/selectors";
import { type ElementVisibility } from "@client/types";
import { createSelector } from "reselect";

export const classNameSelector = combinedClassNameSelector(TargetSelector.Layout, [
  "footerBackgroundOverlay",
  "footerTextColor"
]);
export const elementsSelector = getLayoutSettingValueSelector("elements", "footer");
export const styleSelector = combinedStyleSelector(TargetSelector.Layout, ["padding"], "footer");
export const visibilitySelector = createSelector(
  [getSettingSelector(TargetSelector.Layout, "footer"), getVisibilitySelector(TargetSelector.Layout, "footer")],
  (footer, visibility): ElementVisibility => ({
    isVisible: !!footer && visibility.isVisible
  })
);
